import BundledTextEditor from './BundledTextEditor';
import * as S from './styled/TextEditor.styled';

const TextEditor = (props) => {
	const { value, setValue, initProps } = props;

	return (
		<S.Container>
			<BundledTextEditor
				init={{
					height: '100%',
					...initProps
				}}
				value={value}
				onEditorChange={(value) => {
					setValue(value);
				}}
			/>
		</S.Container>
	);
};

export default TextEditor;
